export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-00.97b184a7.jpg";